import React from 'react';
import { painPoints } from '../data/painPoints';
import { Reveal } from './Reveal';
export function PainPointsSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-106" data-mp="2htbopmh5dzgg">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-107" data-mp="2wpknyo11gcsv">
        <h2 className="text-3xl font-black uppercase tracking-tight text-brand-navy md:text-4xl" data-id="element-108" data-mp="2wmyegiul7n80">
          🏐 Czy rozpoznajesz siebie w tych sytuacjach?
        </h2>
        <p className="mt-4 text-brand-gray" data-id="element-109" data-mp="35oerkycse3fx">
          Jeśli choć jedna z nich brzmi znajomo — Gotowi na Siatkówkę powstało właśnie dla Ciebie.
        </p>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-110" data-mp="3ffj2nmzcd45h">
          {painPoints.map(({
          icon: PointIcon,
          text
        }) => <article key={text} className="flex items-center gap-4 rounded-2xl border border-brand-navy/[0.06] bg-brand-alt p-5 text-left shadow-sm" data-id="element-111" data-mp="3ahhcki3i04ki">
              <PointIcon className="h-6 w-6 shrink-0 text-brand-coral" aria-hidden="true" data-id="element-112" data-mp="3kff013dj9xc2" />
              <span className="text-sm font-semibold leading-snug" data-id="element-113" data-mp="svjjxt7anjnf">{text}</span>
            </article>)}
        </div>
        <p className="mt-12 font-display text-2xl font-black italic text-brand-coral" data-id="element-114" data-mp="wx4tb4kmdfsv">
          A zasługujesz na znacznie więcej.
        </p>
      </Reveal>
    </section>;
}